import styled from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "ExtractionTitlestyles__Container",
  componentId: "keen-query-creator__sc-1lxymj7-0"
})(["&&&{display:flex;align-items:center;flex-wrap:wrap;column-gap:10px;}"]);
export var MessageContainer = styled.div.withConfig({
  displayName: "ExtractionTitlestyles__MessageContainer",
  componentId: "keen-query-creator__sc-1lxymj7-1"
})(["&&&{margin-bottom:3px;line-height:17px;}"]);
export var FullExtraction = styled.div.withConfig({
  displayName: "ExtractionTitlestyles__FullExtraction",
  componentId: "keen-query-creator__sc-1lxymj7-2"
})(["&&&{font-size:13px;font-family:'Lato Regular',sans-serif;color:", ";}"], transparentize(0.3, colors.black[100]));
export var FilteredExtraction = styled.div.withConfig({
  displayName: "ExtractionTitlestyles__FilteredExtraction",
  componentId: "keen-query-creator__sc-1lxymj7-3"
})(["&&&{font-family:'Lato Regular',sans-serif;font-size:14px;color:", ";}"], transparentize(0.3, colors.black[100]));
export var ClearProperties = styled.span.withConfig({
  displayName: "ExtractionTitlestyles__ClearProperties",
  componentId: "keen-query-creator__sc-1lxymj7-4"
})(["&&&{font-family:'Lato Bold',sans-serif;color:", ";cursor:pointer;}"], colors.blue[100]);